import React, { Component, Fragment } from 'react';
import Navbar from "../layout/Navbar";
import Footer from '../layout/Footer';
import AuthService from '../auth/services/authService';
import SearchService from './services/SearchService';
import {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBBtn,
    MDBInput,
    MDBDataTable,
    MDBCard, MDBCardBody, MDBCollapseHeader,MDBCollapse,
    MDBTabPane, MDBTabContent, MDBNav, MDBNavItem, MDBNavLink
  } from "mdbreact";

class Search extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: '',
            searchData: [],
            collapseID: "collapse1",
            loading: true,
            items: {
                default: "1",
            }
        }
    }
    togglePills = (type, tab) => e => {
        e.preventDefault();
        if (this.state.items[type] !== tab) {
          let items = { ...this.state.items };
          items[type] = tab;
          this.setState({
            items
          });
        }
      };
      toggleCollapse = collapseID => () =>
      this.setState(prevState => ({
        collapseID: prevState.collapseID !== collapseID ? collapseID : ""
      }));

    handleChange = (e) => {
        this.setState({
            [e.target.id] : e.target.value
        })
    }
    searchInstitution = (e) => {
        e.preventDefault();
        const s = {
            id: this.state.search + '%'
        }
        AuthService.apiAuth().then((res) => {
            const token = res.data;
            const authToken = token.TOKEN;
            SearchService.searchInst(authToken, {jsStruct: JSON.stringify(s)}).then(res => {
                const searchData = res.data.rows;
                this.setState({ searchData, loading: false});
            });
        })
    }
    searchTransfer = (e) => {
        e.preventDefault();
        const s = {
            id: this.state.search + '%'
        }
        AuthService.apiAuth().then((res) => {
            const token = res.data;
            const authToken = token.TOKEN;
            SearchService.searchTransfer(authToken, {jsStruct: JSON.stringify(s)}).then(res => {
                const searchData = res.data.rows;
                this.setState({ searchData, loading: false});
            });
        })
    }
    searchCourse = (e) => {
        e.preventDefault();
        const s = {
            id: this.state.search + '%'
        }
        AuthService.apiAuth().then((res) => {
            const token = res.data;
            const authToken = token.TOKEN;
            SearchService.searchCourse(authToken, {jsStruct: JSON.stringify(s)}).then(res => {
                const searchData = res.data.rows;
                this.setState({ searchData, loading: false});
            });
        })
    }


    render() {
        const searchData = this.state.searchData;
        const {loading} = this.state;
        const { collapseID } = this.state;
        const data = {

            columns: [
              {
                label: "Institution Name",
                field: "Institution_Name",
                width: 150,
              },
              {
                label: "Start Date",
                field: "start_Dt",
                width: 150,
              },
              {
                label: "End Date",
                field: "End_Dt",
                width: 150,
              },
              {
                label: "Sinclair Course",
                field: "Sinclair_Course_Nm",
                width: 150,
              },
              {
                label: "Sinclair Course Title",
                field: "Sinclair_Course_Title",
                width: 150,
              },
              {
                label: "Sinclair Credit Hours",
                field: "Equivalent_Credit_Ct",
                width: 150,
              },
              {
                label: "Transfer Course Name",
                field: "Transfer_Course_Nm",
                width: 150,
              },
              {
                label: "Transfer Course Title",
                field: "Transfer_Course_Title_Nm",
                width: 150,
              },
              {
                label: "Transfer Credit Hours",
                field: "Transfer_Credit_Ct",
                width: 150,
              }

            ],
            rows : searchData.map(s => {
                return {
                    Institution_Name: s.Institution_Name,
                    start_Dt: s.start_Dt,
                    End_Dt: s.End_Dt,
                    Sinclair_Course_Nm: s.Sinclair_Course_Nm,
                    Sinclair_Course_Title: s.Sinclair_Course_Title,
                    Equivalent_Credit_Ct: s.Equivalent_Credit_Ct,
                    Transfer_Course_Nm: s.Transfer_Course_Nm,
                    Transfer_Course_Title_Nm: s.Transfer_Course_Title_Nm,
                    Transfer_Credit_Ct: s.Transfer_Credit_Ct
                }
            })
          }


        return (
        <Fragment>
            <Navbar />
            <MDBContainer>
                <MDBRow>
                    <MDBCol size="12" className="mt-3">
                    <MDBCard className="mt-3">
          <MDBCollapseHeader onClick={this.toggleCollapse("collapse1")}>
            About the Military Transcript Equivalency Database
            <i className={ collapseID==="collapse1" ? "fa fa-angle-down rotate-icon" : "fa fa-angle-down" } />
          </MDBCollapseHeader>
          <MDBCollapse id="collapse1" isOpen={collapseID}>
            <MDBCardBody>
            <p>Use this tool as an unofficial guide to see what the most common transferred classes from your Joint Service Transcript (JST) and/or Community College of the Air Force (CCAF) transcripts. If you do not see the course/training you completed listed, it may still be possible to receive credit. Please send your official JST or CCAF transcript for a full evaluation. Note: if you completed training through a DoD institution, you will need to send an additional transcript through ACE National Guide for evaluation. </p>
            </MDBCardBody>
          </MDBCollapse>
        </MDBCard>

        <MDBCard>
          <MDBCollapseHeader onClick={this.toggleCollapse("collapse2")}>
            How to Navigate
            <i className={ collapseID==="collapse2" ? "fa fa-angle-down rotate-icon" : "fa fa-angle-down" } />
          </MDBCollapseHeader>
          <MDBCollapse id="collapse2" isOpen={collapseID}>
            <MDBCardBody>
                <p><b>Search by Institution:</b> Search by school/transcript name (Examples: United States Army, Community College of the Air Force) </p>
                <p><b>Search by Transfer Course Name:</b> Search by course names on transcript (Examples: MOS*19D003, AR1729*0050V3)</p>
                <p><b>Search by Sinclair Course:</b> Search by course names at Sinclair (Examples: DIT-216 or ENG-1101)</p>
            </MDBCardBody>
          </MDBCollapse>
        </MDBCard>

        <MDBCard>
          <MDBCollapseHeader onClick={this.toggleCollapse("collapse3")}>
          Database Headers
            <i className={ collapseID==="collapse3" ? "fa fa-angle-down rotate-icon" : "fa fa-angle-down" } />
          </MDBCollapseHeader>
          <MDBCollapse id="collapse3" isOpen={collapseID}>
            <MDBCardBody>
            <p><b>Institution Name:</b> This is the institution where the credit was earned</p>
                        <p><b>Start and End Dates:</b> This is the effective dates of credit earned. Credit received can vary depending on these dates. The variation is caused by training/curriculum changes over periods of time.</p>
                        <p><b>Sinclair Course & Sinclair Course Title:</b> This is the prefix and title of courses offered at Sinclair College</p>
                        <p><b>Transfer Course Name and Transfer Course Title:</b> This is the prefix and title of courses listed on the military transcript</p>
                        <p><b>Sinclair Credit Hours:</b> This indicates how many credit hours were awarded for the Sinclair class</p>
                        <p><b>Transfer Credit Hours:</b> This indicates how many credit hours the course/training were worth at the institution where the credit was earned</p>
            </MDBCardBody>
          </MDBCollapse>
        </MDBCard>

                    </MDBCol>
                    <MDBCol md="8" className="offset-md-2 mt-5">
                        <MDBNav pills color="red darken-2" className="text-center mt-5">
                            <MDBNavItem>
                                <MDBNavLink
                                link
                                to="#"
                                active={this.state.items["default"] === "1"}
                                onClick={this.togglePills("default", "1")}
                                >
                                Search by institution
                                </MDBNavLink>
                            </MDBNavItem>
                            <MDBNavItem>
                                <MDBNavLink
                                link
                                to="#"
                                active={this.state.items["default"] === "2"}
                                onClick={this.togglePills("default", "2")}
                                >
                                Search by Transfer Course Name
                                </MDBNavLink>
                            </MDBNavItem>
                            <MDBNavItem>
                                <MDBNavLink
                                link
                                to="#"
                                active={this.state.items["default"] === "3"}
                                onClick={this.togglePills("default", "3")}
                                >
                                Search by Sinclair Course
                                </MDBNavLink>
                            </MDBNavItem>
                        </MDBNav>
                        <MDBTabContent activeItem={this.state.items["default"]}>
                            <MDBTabPane tabId="1">
                                <form>
                                    <div className="grey-text">
                                        <MDBInput
                                            label="Search by Institution"
                                            icon="search"
                                            id="search"
                                            group
                                            value={this.state.search}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                    <div className="text-center mt-4">
                                    <MDBBtn color="red" className="mb-3" type="submit" onClick={this.searchInstitution}>
                                        Submit Search
                                    </MDBBtn>
                                    </div>
                                </form>
                            </MDBTabPane>
                            <MDBTabPane tabId="2">
                                <form>
                                    <div className="grey-text">
                                        <MDBInput
                                            label="Search by Transfer Course Name"
                                            icon="search"
                                            id="search"
                                            group
                                            value={this.state.search}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                    <div className="text-center mt-4">
                                    <MDBBtn color="red" className="mb-3" type="submit" onClick={this.searchTransfer}>
                                        Submit Search
                                    </MDBBtn>
                                    </div>
                                </form>
                            </MDBTabPane>
                            <MDBTabPane tabId="3">
                                <form>
                                    <div className="grey-text">
                                        <MDBInput
                                            label="Search by Sinclair Course"
                                            icon="search"
                                            id="search"
                                            group
                                            value={this.state.search}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                    <div className="text-center mt-4">
                                    <MDBBtn color="red" className="mb-3" type="submit" onClick={this.searchCourse}>
                                        Submit Search
                                    </MDBBtn>
                                    </div>
                                </form>
                            </MDBTabPane>
                        </MDBTabContent>
                    </MDBCol>
                </MDBRow>
                <MDBRow className="mt-3 mb-5">
                    <MDBCol md="12">
                        <MDBDataTable striped bordered small entries={50} entriesOptions={[50, 100, 150]} data={data} exportToCSV />
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
            <Footer />
        </Fragment> );
    }
}

export default Search;